import { render, staticRenderFns } from "./cpt-dataV-border.vue?vue&type=template&id=114c20a4&scoped=true"
import script from "./cpt-dataV-border.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-border.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114c20a4",
  null
  
)

export default component.exports